import { Badge } from "design-system/atoms/Badge"
import {
  Table,
  TableBody,
  TableCell,
  TableEmptySlate,
  TableHead,
  TableHeader,
  TableRow,
  TableSkeleton,
} from "design-system/molecules/Table"
import { formatDate } from "lopermut"
import { useWhatsappAccountAlertsQuery } from "modules/settings/hooks/whatsapp/useWhatsappAccountAlertsQuery"
import { useTranslation } from "react-i18next"
import { WhatsappTabs } from "./WhatsappTabs"

function getSeverityVariant(severity: string) {
  if (severity === "WARNING") return "warning"
  if (severity === "ERROR" || severity === "CRITICAL") return "negative"
  return "secondary"
}

function getStatusVariant(status: string) {
  if (status === "ACTIVE") return "warning"
  return "secondary"
}

export function WhatsappAccountAlerts() {
  const { t } = useTranslation()
  const { data, isPending } = useWhatsappAccountAlertsQuery()
  const colSpans = [3, 2, 2, 6, 2]

  function renderContent() {
    if (isPending || data === undefined) {
      return <TableSkeleton colSpans={colSpans} />
    }

    if (data.length === 0) {
      return (
        <TableEmptySlate
          colSpan={colSpans.reduce((acc, colSpan) => acc + colSpan, 0)}
          message={t("settings.integrations.whatsapp.alerts.empty")}
        />
      )
    }

    return data.map((alert) => (
      <TableRow key={alert.id}>
        <TableCell colSpan={3}>{alert.type}</TableCell>
        <TableCell colSpan={2}>
          <Badge variant={getSeverityVariant(alert.severity)}>{alert.severity}</Badge>
        </TableCell>
        <TableCell colSpan={2}>
          <Badge variant={getStatusVariant(alert.status)}>{alert.status}</Badge>
        </TableCell>
        <TableCell colSpan={6} className="whitespace-normal text-muted-foreground">
          {alert.description}
        </TableCell>
        <TableCell colSpan={2}>{formatDate(alert.occurredAt ?? alert.updatedAt, "Pp")}</TableCell>
      </TableRow>
    ))
  }

  return (
    <>
      <WhatsappTabs />
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead colSpan={3}>{t("settings.integrations.whatsapp.alerts.type")}</TableHead>
            <TableHead colSpan={2}>{t("settings.integrations.whatsapp.alerts.severity")}</TableHead>
            <TableHead colSpan={2}>{t("settings.integrations.whatsapp.alerts.status")}</TableHead>
            <TableHead colSpan={6}>
              {t("settings.integrations.whatsapp.alerts.description")}
            </TableHead>
            <TableHead colSpan={2}>
              {t("settings.integrations.whatsapp.alerts.occurredAt")}
            </TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>{renderContent()}</TableBody>
      </Table>
    </>
  )
}
